import { computed } from "vue";
import { useLanguages } from "@/core/composables";

export function useLanguageCheck() {
  const { currentLanguage } = useLanguages();

  const isChineseOrJapanese = computed(() => {
    return currentLanguage.value.cultureName === "zh-CN" || currentLanguage.value.cultureName === "ja-JP";
  });

  const isChinese = computed(() => {
    return currentLanguage.value.cultureName === "zh-CN";
  });

  const isJapanese = computed(() => {
    return currentLanguage.value.cultureName === "ja-JP";
  });
  return {
    isChineseOrJapanese,
    isChinese,
    isJapanese,
  };
}
